import { integrationSyncHistoryService } from '@aslanpay/portal-common-lib';
import { useQuery } from '@tanstack/react-query';

const useFetchIntegrationSyncRunDetail = (syncRunId?: string) => {
  return useQuery({
    queryKey: ['fetchIntegrationSyncRunDetail', syncRunId ?? ''],
    queryFn: () => integrationSyncHistoryService.getRun(syncRunId as string),
    enabled: !!syncRunId,
  });
};

export default useFetchIntegrationSyncRunDetail;
